export { LoaderParserPriority } from './LoaderParser.mjs';
export { loadJson } from './loadJson.mjs';
export { loadTxt } from './loadTxt.mjs';
export { getFontFamilyName, loadWebFont } from './loadWebFont.mjs';
import './textures/index.mjs';
//# sourceMappingURL=index.mjs.map
